<template>
  <div ref="wrap">
    <div class="white">
      <mescroll-vue class="mescroll" :class="{'mescroll1':isIos}" ref="mescroll" :down="mescrollDown" :up="mescrollUp"
                    @init="mescrollInit">
        <div class="list" id="listId">
          <div v-for="(item, i) in dataList" :key="i" class="white">
            <goodsItem :item="item" layoutType="0" source="ALI">
            </goodsItem>
          </div>
        </div>
      </mescroll-vue>
    </div>
  </div>
</template>

<script>
import {taoTop100} from "../../../api/commonV2";

export default {
  name: 'top100',
  data() {
    return {
      dataList: [], //分类商品列表
    }
  },
  methods: {
    // 上拉加载
    upCallback(val) {
      let data = {
        pageNo: val.num
      }
      if (val.num === 1) {
        this.dataList = []
      }
      taoTop100(data).then(res => {
        if (res.result === '0') {
          res.dataList ? this.dataList = this.dataList.concat(res.dataList) : ''
          this.mescroll.endByPage(res.dataList ? res.dataList.length : 0, res.totalPage)
        } else {
          this.mescroll.endByPage(res.dataList ? res.dataList.length : 0, res.totalPage)
        }
      }, err => {
        this.mescroll.endErr()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/tabBar/home/top100.vue